import { render } from "./ViewCompetition.vue?vue&type=template&id=2579069a&scoped=true"
import script from "./ViewCompetition.vue?vue&type=script&lang=js"
export * from "./ViewCompetition.vue?vue&type=script&lang=js"

import "./ViewCompetition.vue?vue&type=style&index=0&id=2579069a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2579069a"]])

export default __exports__